import * as React from 'react';

import * as styles from './index.module.scss';

export interface ArticleSidebarListProps {
  heading: string;
  children: React.ReactNode;
}

const ArticleSidebarList = ({heading, children}: ArticleSidebarListProps) => (
  <section>
    <h3 className={styles.heading}>{heading}</h3>
    <ul className={styles.list}>{children}</ul>
  </section>
);

export default ArticleSidebarList;
